import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const MegaDropdown = ({ item, itemsPerCol, columnTitle }) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 991 : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 991);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Filter out invalid or header items to avoid blanks/icons
  const filteredItems = item.filter(
    (i) => i.title && i.title.trim() !== "" && !i.isHeader
  );

  const colsCount = columnTitle.length || 1;
  const items = [];
  for (let i = 0; i < filteredItems.length; i += itemsPerCol) {
    items.push(filteredItems.slice(i, i + itemsPerCol));
  }

  const handleOpen = (e) => {
    if (isMobile) return;
    e.preventDefault();
    const el = e.target;
    if (el.nextSibling) {
      if (el.parentElement.classList.contains("on")) {
        el.parentElement.classList.remove("on");
        el.nextSibling.style.display = "none";
        el.nextSibling.style.opacity = 0;
      } else {
        el.parentElement.classList.add("on");
        el.nextSibling.style.display = "block";
        el.nextSibling.style.opacity = 1;
      }
    }
  };

  return (
    <ul
      className="dropdown-menu dropdown-item megamenu-content animated"
      role="menu"
      style={{
        display: isMobile ? "block" : undefined,
        opacity: isMobile ? 1 : undefined,
        position: isMobile ? "relative" : undefined,
        width: isMobile ? "100%" : undefined,
        boxShadow: isMobile ? "none" : undefined,
        maxHeight: isMobile ? "calc(100vh - 80px)" : undefined, // limit height on mobile
        overflowY: isMobile ? "auto" : undefined, // make scrollable on mobile
      }}
    >
      <li>
        <div className="row">
          {items.map((colItems, i) => (
            <div
              key={i}
              className={
                "col-menu col-lg-" +
                (colsCount === 3 ? "4" : "3") +
                " col-md-12"
              }
            >
              {!isMobile && columnTitle[i] && (
                <h6 className="title" onClick={handleOpen}>
                  {columnTitle[i]}
                </h6>
              )}

              <div
                className="content animated"
                style={{
                  display: isMobile ? "block" : undefined,
                  opacity: isMobile ? 1 : undefined,
                }}
              >
                <ul className="menu-col">
                  {colItems.map((subItem, index) => (
                    <li key={index}>
                      <Link to={subItem.link || "#"}>
                        {subItem.title || "No Title"}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </li>
    </ul>
  );
};

export default MegaDropdown;
